// extracted by mini-css-extract-plugin
export default {"scrollbar":"HVDropdpwnScroll_module-JLWYPEBZ_scrollbar__3rvd5","thumb":"HVDropdpwnScroll_module-JLWYPEBZ_thumb__hJNn2"};